import { ApiResponse, OssStsTokenResponse } from '@packages/global';
import { httpClient } from '../httpClient';

export const ossDirectUploadApi = {
  async getStsToken(): Promise<OssStsTokenResponse> {
    const response = await httpClient.instance.get<ApiResponse<OssStsTokenResponse>>('/user/upload/sts-token');
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || '获取 STS Token 失败');
    }
    return response.data.data;
  }
};
